import { find, findIndex } from 'lodash';

export const chooseNetworkingMethod = networkingData => {
    const route = networkingData.LAN.Status === '1' && networkingData.WAN.Status === '1';

    return route ? 'Route' : 'Switch';
};

export const setLANData = lanData => ({
    Method: lanData.Method === 'dhcp' ? 'DHCP' : 'Static',
    IPAddress: lanData.IPAddress || '',
    Netmask: lanData.Netmask || '',
    Gateway: lanData.Gateway || '',
    Status: lanData.Status || '1'
});

export const setWANData = wanData => ({
    Method: wanData.Method === 'dhcp' ? 'DHCP' : 'Static',
    IPAddress: wanData.IPAddress || '',
    Netmask: wanData.Netmask || '',
    Gateway: wanData.Gateway || '',
    Status: wanData.Status || '1'
});

export const buildInitialTrunks = trunksQtty => {
    const trunks = [];

    for (let index = 0; index < trunksQtty; index++) {
        trunks.push({
            Name: `FXO ${index + 1}`,
            AccessNumber: ''
        });
    }

    return trunks;
};

export const updateTimer = (action, state) => {
    const stateCopy = { ...state };

    stateCopy.timer = action.payload.value === 0 ? 50 : action.payload.value;

    return stateCopy.timer;
};

export const updateStep = (action, state) => {
    const stepsCopy = [...state.steps];
    const previousStep = find(stepsCopy, ['key', action.payload.data.Key]);
    const previousStepIndex = findIndex(stepsCopy, ['key', action.payload.data.Key]);
    const previousStepCopy = { ...previousStep };

    stepsCopy[previousStepIndex] = {
        key: previousStepCopy.key,
        title: previousStepCopy.title,
        description: previousStepCopy.description,
        ...action.payload.data
    };

    return stepsCopy;
};
